import { Tabs, Tab } from '@material-ui/core';
import React, { Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import createShowIf from 'v2/components/Shared/createShowIf';

import Affiliates from './Affiliates';
import General from './General';
import Payment from './Payment';

const tabs = ['Geral', 'Cobrança', 'Parceiros', 'Afiliados', 'Entrega', 'Avançado'];

function Digital() {
  const ShowIf = createShowIf<string>();
  const [currentTab, setCurrentTab] = useState('Geral');

  return (
    <Fragment>
      <Tabs value={currentTab}>
        {tabs.map((tab: string) => (
          <Tab key={`tab-${tab}`} id={`tab-${tab}`} value={tab} label={tab} onClick={() => setCurrentTab(tab)}></Tab>
        ))}
      </Tabs>
      <ShowIf value={currentTab} compare={{ eq: 'Geral' }}>
        <General />
      </ShowIf>
      <ShowIf value={currentTab} compare={{ eq: 'Cobrança' }}>
        <Payment />
      </ShowIf>
      <ShowIf value={currentTab} compare={{ eq: 'Afiliados' }}>
        <Affiliates />
      </ShowIf>
    </Fragment>
  );
}

export default withRouter(Digital);
